import React from 'react';
import {BenefitTag} from '@bonprix/design-system';

export default function Benefits({benefits}) {

    if (benefits.length > 0) {
        return (
            <div className="alpi__article-benefits">
                {benefits.map((benefit, index) => {
                        return (<div key={index} className="alpi__article-benefit">
                            <BenefitTag variant={benefit.displayType.toLowerCase()} size="small">{benefit.name}</BenefitTag>
                        </div>);
                    }
                )}
            </div>);
    }
    return <></>;
}